.trigger {
  /* Suppress the native long-press callout/selection on touch. */
  -webkit-touch-callout: none;
}

.positioner {
  z-index: 1100;
  outline: 0;
}

/* Raise Base UI's dismiss backdrop just under the popup so it works inside a
   Modal too (same trick as the Select primitive). */
:global([data-slot="context-menu-portal"] > [role="presentation"]:not([data-slot])) {
  z-index: 1099;
}

.popup {
  box-sizing: border-box;
  min-width: 180px;
  max-height: var(--available-height);
  padding: var(--list-spacing) 0;
  overflow-y: auto;
  font-size: var(--font-size-base);
  line-height: var(--line-height-base);
  color: var(--dropdown-link-color);
  background-color: var(--dropdown-bg);
  border: 1px solid var(--dropdown-border);
  background-clip: padding-box;
  border-radius: var(--input-border-radius);
  box-shadow: var(--dropdown-shadow);
  outline: 0;
  transform-origin: var(--transform-origin);
  transition: opacity 120ms ease, transform 120ms ease;
}

.popup[data-starting-style],
.popup[data-ending-style] {
  opacity: 0;
  transform: scale(0.96);
}

.item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: calc(var(--padding-base-y) + 1px) var(--content-padding-base);
  margin-bottom: 1px;
  line-height: var(--line-height-base);
  color: var(--dropdown-link-color);
  cursor: pointer;
  user-select: none;
  outline: 0;
  overflow: hidden;
}

.item:last-child {
  margin-bottom: 0;
}

/* Grey hover/keyboard highlight — the app's dropdown-item hover grey. */
.item[data-highlighted],
.submenuTrigger[data-popup-open] {
  background-color: var(--dropdown-link-hover-bg);
}

.item[data-disabled] {
  color: var(--dropdown-link-disabled-color);
  background-color: transparent;
  cursor: not-allowed;
}

.itemText {
  flex: 1;
  min-width: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Link items are <a> — cancel the global anchor underline/colour. */
.linkItem,
.linkItem:hover,
.linkItem:focus {
  color: var(--dropdown-link-color);
  text-decoration: none;
}

/* Leading slot for the checkbox tick / radio dot — reserves width so labels align.
   line-height: 0 kills the inner line-box strut so the glyph is flex-centered
   geometrically; baseline alignment puts the scaled-down radio dot too low. */
.indicator {
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1em;
  line-height: 0;
}

.radioDot {
  font-size: 0.5em;
}

.submenuTrigger {
  padding-right: var(--padding-base-x);
}

.submenuChevron {
  flex: none;
  margin-left: auto;
  padding-left: 8px;
  color: var(--dropdown-trigger-color);
}

.groupLabel {
  padding: calc(var(--padding-base-y) + 1px) var(--content-padding-base);
  margin-top: var(--list-spacing);
  font-size: var(--font-size-mini);
  line-height: var(--line-height-mini);
  color: var(--text-muted);
  text-transform: uppercase;
}

.separator {
  height: 1px;
  margin: var(--list-spacing) 0;
  overflow: hidden;
  background-color: var(--dropdown-divider-bg);
}
